<template>
  <div class="contactUs">
    <!-- 联系我们 -->
    <div class="concat">
      <div class="g-box">
        <div class="concat-con">
          <div class="le">
            <div class="tit">联系我们</div>
            <div class="sub-tit">
              {{ concatInfo.tips }}
            </div>
            <div class="phone">{{ concatInfo.title }}</div>
            <div class="address">{{ concatInfo.subtitle }}</div>
          </div>
          <div class="line"></div>
          <div class="ri">
            <div class="tit">你也可以留下联系方式</div>
            <div class="sub">专业顾问致电您的电话</div>
            <div class="item">
              <input
                v-model="form.name"
                placeholder="请输入姓名"
                class="ipt"
                type="text"
              />
            </div>
            <div class="item">
              <input
                v-model="form.phone"
                placeholder="请输入电话"
                class="ipt"
                type="text"
              />
            </div>
            <div class="btn" @click="submit">提交</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

import { Message } from "element-ui";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      concatInfo: {},
      query: this.$route.query,
      domain: "",
      form: {}
    };
  },
  components: {},
  mounted() {
    document.title = "浙江华博特教育_联系方式_联系地址_报名电话";
  },
  methods: {
    async init() {
      const domain = document.domain;
      this.domain = domain;
      console.log(domain, "domain");
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1,
        menuId: this.query.id
      });
      this.concatInfo = data[0];
    },
    submit() {
      if (!this.form.name) return Message("请先输入姓名");
      if (!this.form.phone) return Message("请先输入手机号");
      this.$api.ums.promote.backgroundMessage_messageForClient
        .post({ ...this.form, address: this.domain })
        .then(() => {
          Message.success("提交成功，请耐心等待老师与您联系");
          this.form = {};
        });
    }
  }
};
</script>
<style lang="less">
.contactUs {
  background: url("../../assets/img/concat.png") no-repeat center;
  background-size: cover;
  height: 640px;
  .concat {
    padding: 100px 0;
    background: url("../../assets/img/concat.png") no-repeat center;
    background-size: cover;
    &-con {
      padding: 60px;
      background: #fff;
      display: flex;
      .le {
        padding-right: 70px;
        width: 480px;
        box-sizing: border-box;
        // border-right: 1px solid #a8aab8;
        .tit {
          font-size: 44px;
          font-weight: 500;
          color: #000000;
        }
        .sub-tit {
          padding-top: 20px;
          font-size: 16px;
          color: #656878;
        }
        .phone {
          padding-top: 60px;
          font-size: 56px;
          font-weight: bold;
          color: #ff8012;
        }
        .address {
          padding-top: 20px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #656878;
          line-height: 22px;
          text-shadow: 0px 0px 40px rgba(0, 48, 170, 0.1);
        }
      }
      .line {
        width: 1px;
        height: 300px;
        background-color: rgba(168, 170, 184, 0.34);
      }
      .ri {
        padding-left: 70px;

        text-align: center;
        width: 480px;
        .tit {
          font-size: 24px;
          font-weight: 600;
          color: #000;
        }
        .sub {
          padding-top: 4px;
          font-size: 16px;
          color: #a8aab8;
        }
        .item {
          margin-top: 30px;
          .ipt {
            padding-left: 20px;
            width: 400px;
            height: 44px;
            background: #f2f4f9;
            border: none;
            box-sizing: border-box;
          }
        }
        .btn {
          margin-top: 50px;
          margin-left: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 400px;
          height: 44px;
          background: #ff8012;
          border-radius: 2px;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
